// src/pages/Contributions.js
import React, { useEffect, useState } from "react";
import { apiFetch } from "../api";

export default function Contributions(){
  const [list, setList] = useState([]);
  useEffect(()=> {
    apiFetch("contributions").then(d => {
      // some servers may expose contributions via a custom route; fall back to fetching raw json
      if(d.contributions) setList(d.contributions);
      else {
        // try direct JSON file
        fetch(`${process.env.REACT_APP_API_BASE_URL}/data/contributions.json`).then(r=>r.json()).then(j=>setList(j.contributions || []));
      }
    });
  },[]);
  return (
    <div className="page">
      <h2>Contributions</h2>
      <table className="table">
        <thead><tr><th>ID</th><th>Project</th><th>Name</th><th>Email</th><th>Stage</th><th>Date</th></tr></thead>
        <tbody>
          {list.map(c => (
            <tr key={c.id}><td>{c.id}</td><td>{c.project_title}</td><td>{c.name}</td><td>{c.email}</td><td>{c.project_stage}</td><td>{c.date}</td></tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
